import { EyeInvisibleOutlined, EyeOutlined, WarningOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './styles';

export type AmountToggleProps = {
  showValue: boolean;
  warning: boolean;
  setShowValue: () => void;
};

function AmountToggle({ showValue, warning, setShowValue }: AmountToggleProps) {
  const { t } = useTranslation('translation', { keyPrefix: 'header' });

  if (warning) 
    return (
      <S.DisplayIconShowOrHideValue>
        <Popover
          content={t('balanceWarning')}
        >
          <WarningOutlined />
        </Popover>
      </S.DisplayIconShowOrHideValue>
    );

  return (
    <S.DisplayIconShowOrHideValue>
      {showValue ? (
        <EyeOutlined onClick={() => setShowValue()} />
      ) : (
        <EyeInvisibleOutlined onClick={() => setShowValue()} />
      )}
    </S.DisplayIconShowOrHideValue>
  );
}

export default memo(AmountToggle);
